import { render, staticRenderFns } from "./SiteLogo.vue?vue&type=template&id=436cb0f3&scoped=true&"
var script = {}
import style0 from "./SiteLogo.vue?vue&type=style&index=0&id=436cb0f3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436cb0f3",
  null
  
)

export default component.exports